import React, { useEffect, useState } from 'react'
import Modal from '../../../../components/Modal'
import NFTButton from '../NFTButton'
import { Input as NumericalInput } from '../../../../components/NumericalInput'
import { useApproveCallbackFromNFT, useGetSaleTokenItem, usePutOnSale } from '../../../../hooks/useNFTMarketPlace'
import { ApprovalState } from '../../../../hooks/useApproveCallback'
import CategoryList from '../../data/NFTCategoryList'
import INFTCategory from '../../models/INFTCategory'
import ComboBox from '../../../../components/ComboBox'
import { SaleTokenList } from '../../data/SaleTokenList'
import { useActiveWeb3React } from '../../../../hooks'
import { ChainId } from '@yetiswap/sdk'
import NFTCurrencyDropdown from '../NFTCurrencyDropdown'
import { INFTSellModalProps } from './models/INFTSellModal'
import {
  NFTSaleTypeWrapper,
  NFTSellModalButtons,
  NFTSellModalForm,
  NFTSellModalMeta,
  NFTSellModalWrapper
} from './styles/styled'
import YTSNFTFee from './components/YTSNFTFee'
import NonYTSNFTFee from './components/NonYTSNFTFee'
import CollectionList, { CollectionObjectList } from '../../data/NFTCollectionsList'
import { ReactComponent as PriceTags } from '../../../../assets/images/price-tags.svg'
import { ReactComponent as Clock } from '../../../../assets/images/clock.svg'
import { ReactComponent as Infinity } from '../../../../assets/images/infinity.svg'

export default function NFTSellModal(props: INFTSellModalProps) {
  const {
    isOpen,
    onDismiss,
    NFTName,
    tokenContractAddress,
    tokenId,
    getSalesNFTItems,
    //account,
    yetiswapMarketCommissionRateYTS,
    yetiswapMarketCommissionRateNonYTS,
    priceInfo
  } = props
  const { chainId, account } = useActiveWeb3React()
  const initialCurrency = SaleTokenList[0][chainId ? chainId : ChainId.BOBA]
  const [sellPrice, setSellPrice] = useState('')
  const [NFTCategory, setNFTCategory] = useState(0)
  const [categoryError, setCategoryError] = useState(false)
  const [nftCurrency, setNftCurrency] = useState(initialCurrency)
  const [approveState, approveCallback] = useApproveCallbackFromNFT(tokenId, tokenContractAddress)
  const [approvePending, setApprovePending] = useState(ApprovalState.NOT_APPROVED)

  const minPrice = 0.00001
  const maxPrice = 999999999

  const [putOnSaleCallBack] = usePutOnSale(tokenContractAddress, tokenId, sellPrice, NFTCategory, nftCurrency)

  const saleTokenItem = useGetSaleTokenItem(nftCurrency)
  const foundedContract = CollectionObjectList[tokenContractAddress.toLowerCase()]
  const sellPriceText = sellPrice ? `${sellPrice} ${saleTokenItem.symbol}` : ''

  useEffect(() => {
    if (foundedContract && foundedContract !== 0) {
      setNFTCategory(foundedContract)
    }
  }, [setNFTCategory, tokenContractAddress, foundedContract])

  function nftButtonClick() {
    if (!sellPrice) {
      setCategoryError(true)
    } else if (approveState !== ApprovalState.APPROVED) {
      approveCallback()
        .then(() => {
          setApprovePending(ApprovalState.APPROVED)
        })
        .catch(() => {
          setApprovePending(ApprovalState.NOT_APPROVED)
        })
      setApprovePending(ApprovalState.PENDING)
    } else if (NFTCategory !== 0 && sellPrice) {
      setApprovePending(ApprovalState.PENDING)
      putOnSaleCallBack()
        .then(() => {
          setApprovePending(ApprovalState.APPROVED)
          onDismiss()
          setTimeout(() => getSalesNFTItems(), 2000)
        })
        .catch(() => {
          setApprovePending(ApprovalState.NOT_APPROVED)
        })
    } else if (NFTCategory === 0) {
      setCategoryError(true)
    }
  }

  function setNFTSellPrice(val: any) {
    const value = parseFloat(val)
    const valueString = val.toString()
    const minPriceString = minPrice.toString()
    const splitedValue = val.split('.')

    if (val !== '.') {
      if (value > 1 && splitedValue.length > 0 && splitedValue[1] && splitedValue[1].length > 5) {
        const newSellPrice = splitedValue[0] + '.' + splitedValue[1].substring(0, 5)
        setSellPrice(newSellPrice)
      } else if (minPrice > value && value !== 0) {
        setSellPrice(minPrice.toString())
      } else if (maxPrice < value) {
        setSellPrice(maxPrice.toString())
      } else if (value < 1 && valueString.length > minPriceString.length) {
        setSellPrice(valueString.substring(0, minPriceString.length))
      } else {
        setSellPrice(val)
      }
    }
  }

  function closeSellModal() {
    onDismiss()
  }

  return (
    <Modal isOpen={isOpen} onDismiss={closeSellModal} maxHeight={90}>
      <NFTSellModalWrapper>
        <NFTSellModalMeta>{NFTName}</NFTSellModalMeta>
        <NFTSellModalForm>
          <div className="form-item">
            <div className="form-label">Price</div>
            <div className="price-amount">
              <NumericalInput
                className="sell-price-amount"
                value={sellPrice !== null ? sellPrice : ''}
                onUserInput={(val: any) => {
                  setNFTSellPrice(val)
                }}
                min={minPrice}
                max={maxPrice}
                maxLength={10}
              />
              <div className="price-currency">
                <NFTCurrencyDropdown defaultValue={nftCurrency} onChange={(val: any) => setNftCurrency(val)} />
              </div>
            </div>
          </div>
          <NFTSaleTypeWrapper>
            <div className="sale-type-item active">
              <PriceTags />
              <div className="sale-type-item-text">Fixed Price</div>
            </div>
            <div className="sale-type-item disabled">
              <Clock />
              <div className="sale-type-item-text">Timed Auction</div>
              <div className="coming-soon">Coming Soon</div>
            </div>
            <div className="sale-type-item disabled">
              <Infinity />
              <div className="sale-type-item-text">Unlimited Auction</div>
              <div className="coming-soon">Coming Soon</div>
            </div>
          </NFTSaleTypeWrapper>
          {!foundedContract && (
            <div className="form-item">
              <div className="form-label">Category</div>
              <div className="form-input">
                <ComboBox
                  value={NFTCategory}
                  onChange={(val: any) => {
                    setNFTCategory(parseInt(val ? val : '0', 0))
                    setCategoryError(parseInt(val ? val : '0', 0) === 0)
                  }}
                >
                  <option />
                  {CategoryList.filter((item: INFTCategory) => item.id).map((item: INFTCategory) => (
                    <option key={`${item.id}_CATEGORY_ITEM`} value={item.id ? item.id : 0}>
                      {item.name}
                    </option>
                  ))}
                </ComboBox>
              </div>
            </div>
          )}
        </NFTSellModalForm>
        <div>
          {tokenContractAddress.toLowerCase() === CollectionList[0].tokenAddress.toLowerCase() ? (
            <YTSNFTFee
              tokenId={tokenId}
              account={account as string}
              price={sellPrice}
              commissionRate={
                initialCurrency === nftCurrency
                  ? parseInt(yetiswapMarketCommissionRateYTS)
                  : parseInt(yetiswapMarketCommissionRateNonYTS)
              }
              tokenName={saleTokenItem.symbol}
              priceInfo={priceInfo}
            />
          ) : (
            <NonYTSNFTFee
              account={account as string}
              tokenId={tokenId}
              price={sellPrice}
              commissionRate={
                initialCurrency === nftCurrency
                  ? parseInt(yetiswapMarketCommissionRateYTS)
                  : parseInt(yetiswapMarketCommissionRateNonYTS)
              }
              tokenName={saleTokenItem.symbol}
              collectionAddress={tokenContractAddress}
              priceInfo={priceInfo}
            />
          )}
        </div>
        {categoryError && (
          <div className="category-error">
            {sellPrice ? '' : 'Please set price'}
            {!sellPrice && NFTCategory === 0 && <br />}
            {NFTCategory === 0 ? 'Please select category' : ''}
          </div>
        )}
        <NFTSellModalButtons>
          <NFTButton
            className={approvePending === ApprovalState.PENDING ? 'pending' : ''}
            disable={approvePending === ApprovalState.PENDING}
            text={approveState !== ApprovalState.APPROVED ? `Approve` : `Sell ${sellPriceText}`}
            onClick={nftButtonClick}
          />
          <NFTButton onClick={() => closeSellModal()} text="Cancel" />
        </NFTSellModalButtons>
      </NFTSellModalWrapper>
    </Modal>
  )
}
